import type { OutreachIntent } from '@discovr/types';
import { cn } from '../../../lib/utils';

export const INTENT_LABELS: Record<OutreachIntent, string> = {
  quoted_rates: 'Quoted rates', negotiating: 'Negotiating', interested_no_rates: 'Interested',
  not_interested: 'Not interested', question: 'Question', auto_reply: 'Auto-reply', unsubscribe: 'Unsubscribed',
};

const TONE: Record<OutreachIntent, string> = {
  quoted_rates: 'bg-emerald-100 text-emerald-700', negotiating: 'bg-amber-100 text-amber-700',
  interested_no_rates: 'bg-[var(--brand-100)] text-[var(--brand-600)]', not_interested: 'bg-stone-200 text-stone-600',
  question: 'bg-blue-100 text-blue-700', auto_reply: 'bg-[var(--stone-100)] text-(--foreground-secondary-default)', unsubscribe: 'bg-rose-100 text-rose-700',
};

const SIZES = { sm: 'px-2 py-[2px] text-[11px]', md: 'px-3 py-[5px] text-[12px]', tag: 'shrink-0 px-2 py-1 text-[12px]/4 uppercase' } as const;

/** `tag`: Figma's Tag shape, for the thread message head (170:4090). */
export function IntentPill({ intent, size = 'md' }: { intent?: OutreachIntent; size?: keyof typeof SIZES }) {
  if (!intent) return null;
  return <span data-part="intent" className={cn('inline-flex items-center whitespace-nowrap rounded-full font-medium', SIZES[size], TONE[intent])}>{INTENT_LABELS[intent]}</span>;
}
